var _jsxFileName = "C:\\github\\os\\react-most-wanted\\packages\\rmw-shell\\src\\containers\\App\\App.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import A2HSProvider from 'a2hs';
import Loadable from 'react-loadable';
import LoadingComponent from '../../components/LoadingComponent';
import React from 'react';
import config from '../../config';
import configureStore from '../../store';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux'; //import RootAsync from 'rmw-shell/lib/containers/Root'

import Analytics from '../../containers/Analytics/Analytics';

const Loading = () => /*#__PURE__*/React.createElement(LoadingComponent, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 12,
    columnNumber: 23
  }
});

export const RootAsync = Loadable({
  loader: () => import('rmw-shell/lib/containers/Root'),
  loading: Loading
});

const App = ({
  appConfig
}) => {
  const store = appConfig && appConfig.configureStore ? appConfig.configureStore() : configureStore();

  const configs = _extends({}, config, {}, appConfig);

  const _configs$landingPage = configs.landingPage,
        LandingPage = _configs$landingPage === void 0 ? false : _configs$landingPage;
  return (/*#__PURE__*/React.createElement(A2HSProvider, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 28,
        columnNumber: 5
      }
    }, /*#__PURE__*/React.createElement(Provider, {
      store: store,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(BrowserRouter, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 30,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(Switch, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 31,
        columnNumber: 11
      }
    }, LandingPage && /*#__PURE__*/React.createElement(Route, {
      path: "/",
      exact: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 33,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(React.Fragment, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 34,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(LandingPage, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35,
        columnNumber: 19
      }
    }), configs.analyticsProps && /*#__PURE__*/React.createElement(Analytics, _extends({}, configs.analyticsProps, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37,
        columnNumber: 21
      }
    })))), /*#__PURE__*/React.createElement(Switch, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Route, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 43,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(RootAsync, {
      appConfig: configs,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 44,
        columnNumber: 17
      }
    })))))))
  );
};

export default App;